'use strict';

angular.module('programme')

.component('sponsors', {
    templateUrl: 'modules/programme/components/sponsors/sponsors.html'
});
